import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import { WishlistProvider } from './contexts/WishlistContext';
import Login from './pages/Login';
import VerifyOTP from './pages/VerifyOTP';
import CompleteSignup from './pages/CompleteSignup';
import Home from './pages/Home';
import PropertyDetails from './pages/PropertyDetails';
import CreateProperty from './pages/CreateProperty';
import EditProperty from './pages/EditProperty';
import MyProperties from './pages/MyProperties';
import Wishlist from './pages/Wishlist';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ToastProvider>
      <WishlistProvider>
      <BrowserRouter>
        <Routes>
          {/* Auth Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/complete-signup" element={<CompleteSignup />} />
          
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/property/:id" element={<PropertyDetails />} />
          
          {/* Protected Routes */}
          <Route 
            path="/create-property" 
            element={
              <ProtectedRoute>
                <CreateProperty />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/edit-property/:id" 
            element={
              <ProtectedRoute>
                <EditProperty />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/my-properties" 
            element={
              <ProtectedRoute>
                <MyProperties />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/wishlist" 
            element={
              <ProtectedRoute>
                <Wishlist />
              </ProtectedRoute>
            } 
          />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </WishlistProvider>
    </ToastProvider>
  );
}

export default App;
